/**
 * Returns the name for the given route.
 * @param {Route} route
 * @returns {string}
 */
export function getRouteName(route) {
  if (route.meta && route.meta.name) {
    if (typeof route.meta.name === 'function') {
      return route.meta.name(route)
    } else {
      return route.meta.name
    }
  }

  return ''
}

/**
 * Returns an array of routes below the given route in the nested structure including names, paths and route data.
 * @param {VueRouter} router
 * @param {Route} route
 * @return {Array<{route: Route, name: string, fullPath: string, path: string}>}
 */
export function getRouteStructure(router, route) {
  return (
    route.path
      // Remove any trailing / from the path
      .replace(/\/$/, '')
      // Split the path into sections
      .split('/')
      // Loop over all sections and find their routes, names, etc.
      .reduce((parentCrumbs, path) => {
        const crumb = { path }

        parentCrumbs.push(crumb)

        // Determine the full path based on the parent crumbs (defaults to '/' if an empty path is generated)
        crumb.fullPath = parentCrumbs.map(crumb => crumb.path).join('/') || '/'

        // Find the route and name for each path
        crumb.route = router.resolve(crumb.fullPath).route
        crumb.name = getRouteName(crumb.route)

        return parentCrumbs
      }, [])
  )
}
